import React, { Fragment } from 'react'
import { string, array, func, number, bool, object } from 'prop-types'
import ResultsContainer from '../components/results/Container'
import withResults from '../hoc/withResults'
import { ALL } from '../utils/constants'

const ScreensResultsAll = ({
  handleFolderWidgetError, results, widgetsAreLoading, widgets,
  totalDocs, resultsAreLoading, lastQueryUsed, error, ...rest
}) => {
  return (
    <Fragment>
      {!error && (
        <ResultsContainer
          aggregationActive={ALL}
          isLoading={resultsAreLoading}
          query={lastQueryUsed}
          lastQueryUsed={lastQueryUsed}
          results={results}
          totalCount={totalDocs}
          widgets={widgets}
          widgetsAreLoading={widgetsAreLoading}
          handleFolderWidgetError={handleFolderWidgetError}
          {...rest}
        />
      )}
    </Fragment>
  )
}

ScreensResultsAll.propTypes = {
  handleFolderWidgetError: func,
  results: array,
  widgetsAreLoading: bool,
  widgets: object,
  totalDocs: number,
  resultsAreLoading: bool,
  lastQueryUsed: string,
  error: bool
}

export default withResults(ScreensResultsAll, ALL)
